// VAPT #15 (Concurrent User): bridges the axios response interceptor (plain module code, not a
// React component — can't use context directly) to a globally-mounted dialog component, so a
// CONCURRENT_SESSION 409 can ask the user to choose rather than dead-ending on an error.
// Single in-flight prompt is the only case that matters here: a user can only be looking at one
// "you're signed in elsewhere" dialog at a time.

export type ConcurrentSessionChoice = 'take-over' | 'cancel';

type VisibilityListener = (visible: boolean) => void;

let listener: VisibilityListener | null = null;
let pendingResolve: ((choice: ConcurrentSessionChoice) => void) | null = null;

export const subscribeToConcurrentSessionPrompt = (fn: VisibilityListener): (() => void) => {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
};

export const promptConcurrentSessionChoice = (): Promise<ConcurrentSessionChoice> => {
  return new Promise((resolve) => {
    pendingResolve = resolve;
    listener?.(true);
  });
};

export const resolveConcurrentSessionChoice = (choice: ConcurrentSessionChoice): void => {
  listener?.(false);
  pendingResolve?.(choice);
  pendingResolve = null;
};
